import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment/moment';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TextField from '../../../components/TextField/TextField';
import Loading from 'components/Loading/Loading';
import RelatorioEntradasAvulsas from './RelatorioEntradasAvulsas';
//Api
import destino_api from '../../../api/destino_api';
import relatorio_api from '../../../api/relatorio_api';
//Helpers
import { showMessage } from '../../../helpers/message';
import mascaras from '../../../helpers/mascaras';
import { validarCampos, objCampo, PrintValidate } from '../../../helpers/ValidadorDeCampos';
//Estado inicial dos filtros do relatorio
function initialStateFiltros() {
    const dataAtual = new Date();
    dataAtual.setMonth(dataAtual.getMonth() - 1);
    const dataInicial = moment(dataAtual).format("YYYY-MM-DD");
    dataAtual.setMonth(dataAtual.getMonth() + 1);
    const dataFinal = moment(dataAtual).format("YYYY-MM-DD");
    return {
        dataInicial,
        dataFinal,
        destinoId: 0,
        destinoId_selected: null,
        nomeRelatorio: "Relatórios - Entradas Avulsas"
    }
}
export default function EntradasAvulsas() {
    //Estado que valida os possiveis erros nos campos de filtros
    const [errors, setErrors] = useState({});
    //Guarda os filtros obrigatorios
    const campos = [
        objCampo({ name: "dataInicial", required: true }),
        objCampo({ name: "dataFinal", required: true }),
        objCampo({ name: "destinoId_selected", required: true }),
    ]
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState();

    //Estado que guarda os valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros);

    //Opções de destinos
    const [optionsDestinos, setOptionsDestinos] = useState();

    //Estado que guarda os dados do relatorio
    const [dadosRelatorio, setDadosRelatorio] = useState(null);

    //Variavel de navegação na tela
    const navigate = useNavigate();

    //Change para os campos data inicial, data final e status
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }

    //Change para os campos modalidade e transportadores
    const onChangeSelected = (e, select) => {
        const { name } = select;
        setFiltros({
            ...filtros,
            [name]: e,
            [name.split("_")[0]]: e ? e.value : 0
        });
    }

    //Função que puxa os dados do relatorio
    const carregarRelatorio = () => {

        const _errors = validarCampos(filtros, campos);

        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        }
        if (new Date(filtros.dataInicial).getTime() > new Date(filtros.dataFinal).getTime()) {
            setErrors({ dataInicial: { message: "A data inicial não pode ser maior do que a data final" } })
            return;
        } else {
            setErrors({});
        }
        setLoading(true);
        const _filtros = { ...filtros };
        _filtros.dataInicial = _filtros.dataInicial + " 00:00:00";
        _filtros.dataFinal = _filtros.dataFinal + " 23:59:59";
        relatorio_api.EntradasAvulsas(_filtros).then(response => {
            response.data.listaEntradasAvulsas = response.data.listaEntradasAvulsas.map(value => {
                if (value.dataRegistroVeiculo) {
                    value.dataRegistroVeiculo = moment(value.dataRegistroVeiculo).format("DD/MM/YYYY HH:mm:ss");
                }
                if (value.dataRegistroVeiculo) {
                    value.dataEntrada = moment(value.dataEntrada).format("DD/MM/YYYY HH:mm:ss");
                }
                if (value.dataRegistroVeiculo) {
                    value.dataSaida = moment(value.dataSaida).format("DD/MM/YYYY HH:mm:ss");
                }
                value.pesoEntrada = mascaras.floatMask(value.pesoEntrada);
                value.pesoSaida = mascaras.floatMask(value.pesoSaida);
                return value;
            })
            setDadosRelatorio(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }
    //Carrega as modalidades de coleta e os transportadores para o select
    useEffect(() => {
        setLoading(true);
        destino_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.fantasia };
            })
            setOptionsDestinos(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }, []);
    if (dadosRelatorio != null) {
        return <RelatorioEntradasAvulsas dadosRelatorio={dadosRelatorio} btnVoltar={() => setDadosRelatorio(null)} filtros={filtros} />
    }
    return (
        <MainCard btnVoltarInTop={() => navigate(-1)}>
            {loading && <Loading />}
            <h4>Relatório de entradas avulsas</h4>
            <Row>
                <Col sm="12" md="6" lg="4">
                    <TextField name="dataInicial" label={"* Data inicial"} type={"date"} value={filtros.dataInicial} onChange={onChangeFiltros} invalid={!!errors.dataInicial} />
                    <PrintValidate field={"dataInicial"} errors={errors} />
                </Col>
                <Col sm="12" md="6" lg="4">
                    <TextField name="dataFinal" label={"* Data final"} type={"date"} value={filtros.dataFinal} onChange={onChangeFiltros} invalid={!!errors.dataFinal} />
                    <PrintValidate field={"dataFinal"} errors={errors} />
                </Col>
                <Col sm="12" md="6" lg="4">
                    <TextField name="destinoId_selected" label={"* Destino final"} type={"select"} searchable value={filtros.destinoId_selected} invalid={!!errors.destinoId_selected} onChange={onChangeSelected} options={optionsDestinos} />
                </Col>
                <Col sm="12" md="6" lg="4" style={{ marginTop: "1.875rem" }}>
                    <Button className='w-100 fw-bold' color='info text-light' onClick={carregarRelatorio}>Gerar Relatório</Button>
                </Col>
            </Row>
        </MainCard>
    )
}